import { render, staticRenderFns } from "./BaseModalVisualizarInfos.vue?vue&type=template&id=248c0944&lang=pug"
import script from "./BaseModalVisualizarInfos.vue?vue&type=script&lang=js"
export * from "./BaseModalVisualizarInfos.vue?vue&type=script&lang=js"
import style0 from "./BaseModalVisualizarInfos.vue?vue&type=style&index=0&id=248c0944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports